// extracted by mini-css-extract-plugin
module.exports = {"container":"Sponsors-module--container--2rd6p","title":"Sponsors-module--title--1XVPB","list":"Sponsors-module--list--39bRo"};